export default __webpack_public_path__ + "static/media/83090.e7c074a8.jpg";